import {Dispatch} from 'react'
import {FACTURACION_TYPES} from '../../constants/facturacion.types'
import {ClienteF, FacturacionAction} from '../../interfaces/facturacion.interface'
import {State} from '../../reducers'
import {facturacionModalsClose} from './facturacionProductos.actions'
import {facturacionFormClienteValidacionesGenerarFactura} from './facturacionCliente.actions'
import {generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalShowLoader, getFechaHora} from '../general.actions'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {setDatosGeneralesEmisor} from '../catalogos.actions'
import {getFechaFormato1, getHoraNow} from '../../utils/stringDate'
import {getQR} from '../operaciones/operaciones.actions'
import {facturacionFormSucursalValidacion} from './facturacionSucursal.actions'
import {setResultAnulaciones} from '../historial/historial.actions'
import { guardarClienteReceptor } from '../operaciones/clienteReceptor.actions'
import { docsAsociadosReset, docsDatosReceptorSiguiente } from '../documentos/documentos.actions'
import { docsAsociadosItems } from '../../pages/EmitirFactura/Components/GeneracionFactura/OtrosDocAsociados'
import { handleRestartStateFormaPago } from '../forma-pago.actions'
import { unirChipsJoin, unirChipsReturnFirst } from '../../utils/strings.utils'
import { getTransactions } from "../historial/historialFilter.actions"
import {getDigitosCalculables, isEmpresa3Digitos} from "../utils-documentos.actions"

export const facturacionClearAll = (flag: boolean = false) => ({
  type: FACTURACION_TYPES.FACTURACION_CLEAR_ALL,
  payload: flag,
})

export const facturacionSetDatosEmisor = (emisor: any) => ({
  type: FACTURACION_TYPES.SET_DATOS_EMISOR,
  payload: emisor,
})

export const facturacionSetDatosFactura = (factura: any) => ({
  type: FACTURACION_TYPES.SET_DATOS_FACTURA,
  payload: factura,
})

export const facturacionSetFacturaEmitida = (flag: any) => ({
  type: FACTURACION_TYPES.FACTURA_EMITIDA,
  payload: flag,
})

export const facturacionSetActivarOpciones = () => ({
  type: FACTURACION_TYPES.OPCIONES_ACTIVA,
  payload: true,
})

export const facturacionSetCatalogoSucursal = (sucursales: any) => ({
  type: FACTURACION_TYPES.SET_CATALOGO_SUCURSAL,
  payload: sucursales,
})

export const facturacionSetCatalogoSerie = (series: any) => ({
  type: FACTURACION_TYPES.SET_CATALOGO_SERIE,
  payload: series,
})

export const facturacionSetUUID = (uuid: any) => ({
  type: FACTURACION_TYPES.SET_UUID,
  payload: uuid,
})

export const facturacionAnulado = (flag: boolean) => ({
  type: FACTURACION_TYPES.FACTURACION_ANULADO,
  payload: flag,
})

// ******************************************************************************************
export const facturacionSetModalEmitirFactura = (flag: boolean) => ({
  type: FACTURACION_TYPES.MODALFACTURACION_OPEN,
  payload: {activeEmitirFactura: flag},
})

export const facturacionSetModalFacturaEmitida = (flag: boolean) => ({
  type: FACTURACION_TYPES.MODALFACTURACION_OPEN,
  payload: {activeFacturaEmitida: flag},
})

export const facturacionSetModalImpresion = (data: any) => ({
  type: FACTURACION_TYPES.MODALIMPRESION_OPEN,
  payload: data,
})

export const facturacionSetModalEmail = (flag: boolean) => ({
  type: FACTURACION_TYPES.MODALEMAIL_OPEN,
  payload: flag,
})

export const facturacionSetModalAnular = (flag: boolean) => ({
  type: FACTURACION_TYPES.MODALANULAR_OPEN,
  payload: flag,
})

export const facturacionSetModalConfirmarClienteVacio = (flag: boolean) => ({
  type: FACTURACION_TYPES.MODALCONFIRMARCLIENTEVACIO,
  payload: flag,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const facturacionClicGenerarFactura =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    if (facturacionFormClienteValidacionesGenerarFactura(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalInfo('Datos incorrectos en el formulario Datos del Cliente'))
      return false
    }
    if (facturacionFormSucursalValidacion(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalInfo('Datos incompletos en el formulario sucursal y serie'))
      return false
    }
    const array = getState().facturacion.arrayProductos
    if (array.length === 0) {
      dispatch(generalOpenModalInfo('Debe agregar al menos un producto para poder Generar la factura'))
      return false
    }
    if(docsDatosReceptorSiguiente(dispatch, getState)) return false
    return true
  }

export const facturacionClicGenerarNotaCredito =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    if (facturacionFormSucursalValidacion(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalError('Datos incompletos en el formulario sucursal y serie'))
      return false
    }
    return true
  }
// ******************************************************************************************
// ? PETICIONES REST
// ******************************************************************************************
export const facturacionGetDatosEmisor =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const datos = getState().catalogos.datosEmisor
    if (datos !== null && Object.keys(datos).length > 0) {
      dispatch(facturacionSetDatosEmisor(getState().catalogos.datosEmisor))
      return
    }

    http
      .get(ENDPOINTS.FACTURACION_GET_EMPRESA_EMISOR, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res?.message) return dispatch(generalOpenModalError(res.message))
        const response = {
          ...res.body,
          departamento: {
            idDepartamento: res?.body?.departamento,
            valor: res?.body?.departamentonombre,
          },
          municipio: {
            idMmunicipio: res?.body?.municipio,
            valor: res?.body?.municipionombre,
          },
        }
        dispatch(facturacionSetDatosEmisor(response))
        dispatch(setDatosGeneralesEmisor(response))
      })
      .catch((err) => {
        let message = 'No se logró obtener los datos del Emisor'
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
  }

export const facturacionPostSucursales =
  (tipoDte:string = '01') => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const {datos} = getState().userLogin;
    let message = 'No se logró obtener el catalogo de sucursales'
    await http
      .post(ENDPOINTS.FACTURACION_POST_SUCURSALES, {
        idsucursal: `${datos.sucursal_seleccionada}`,
        tipodocumento: tipoDte
      }, {}, KEYS.TOKEN)
      .then(async (response: any) => {
        if (response.body && !response.message) {
          const sucursal = response.body;
          const hayDocs = sucursal[0]?.Documento?.length;
          if (!hayDocs) {
            dispatch(facturacionSetCatalogoSucursal([]))
          } else {
            dispatch(facturacionSetCatalogoSucursal(response.body))
          }
        } else {
          dispatch(generalOpenModalError(response.message || message))
        }
      })
      .catch((err) => {
        if(err?.response?.data?.errorCode === 1) { dispatch(facturacionSetCatalogoSucursal([])); return; }
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
  }

export const facturacionGetUUID =
  (tipoDoc: string | null = null, loader?: boolean) =>
  async (dispatch: Dispatch<FacturacionAction>) => {
    if(loader) dispatch(generalShowLoader(true))
    let message = 'No se logró obtener el UUID del documento'
    const params = {TipoDOc: tipoDoc || '01'}
    await http
      .get(ENDPOINTS.FACTURACION_GET_UUID, params, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body && !res.message) {
          dispatch(facturacionSetUUID(res.body))
          return
        }
        dispatch(generalOpenModalError(res.message || message))
      })
      .catch((err) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => {if(loader)dispatch(generalShowLoader(false))})
  }

export const facturacionClicEmitirFactura =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    if (facturacionFormClienteValidacionesGenerarFactura(dispatch, getState)) {
      dispatch(generalOpenModalInfo('Datos incorrectos en el formulario Datos del Cliente'))
      return false
    }
    if (facturacionFormSucursalValidacion(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalInfo('Datos incompletos en el formulario sucursal y serie'))
      return false
    }
    const array = getState().facturacion.arrayProductos
    if (array.length === 0) {
      dispatch(generalOpenModalInfo('Debe agregar al menos un producto para poder Generar la factura'))
      return false
    }
    if(docsDatosReceptorSiguiente(dispatch, getState)) return false
    dispatch(facturacionSetModalEmitirFactura(true))
  }

export const notaCreditoClickEmitir =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    if (facturacionFormSucursalValidacion(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalError('Datos incompletos en el formulario sucursal y serie'))
      return false
    }
    dispatch(facturacionSetModalEmitirFactura(true))
  }

export const facturacionCloseModalEmitir = () => async (dispatch: Dispatch<FacturacionAction>) => {
  dispatch(facturacionSetModalEmitirFactura(false))
}
/**
 * facturacionClicEmitirModal = emite la factura
 * @param history hook useHistory
 * @returns void
 */
export const facturacionClicEmitirModal =
  (history: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    const {activeDoc} = getState().documentos
    const {unidadesMedida} = getState().catalogos
    const {dataDocsAsociados} = getState().documentos.otrosDocumentosAsociados
    const datosReceptor = getState().documentos.datosReceptor.form
    const user = localStorage.getItem(KEYS.ID_CLIENT)
    const {pagos, formFormaPago} = getState().formaPago
    const userLogin = getState().userLogin

    dispatch(generalShowLoader(true))
    const {formCliente, formSucursal, arrayProductos, calculosArrayProductos, datosUUID} = getState().facturacion
    const horasActuales:any = await dispatch(getFechaHora());


    // Si no es DUI quitar guiones
    let doc = formCliente.numId?.trim() || ''
    if (formCliente.tipoDocumento === KEYS.DOCUMENTO_DUI_ID && doc.length > 1) doc = `${doc.substring(0,doc.length-1)}-${doc[doc.length-1]}`
    let totalDigitos = getDigitosCalculables(userLogin?.datos?.codigo_empresa)

    let body: any = {
      id_user: user,
      facturas: [
        {
          receptorManual: datosReceptor.nombre,
          docManual: datosReceptor.numId,
          esReceptorManual : datosReceptor.esReceptorManual,
          tipoDocManual : datosReceptor.nombreTipoDocumento,
          idsucursaldocumento: formSucursal?.datosSerie?.idsucursaldocumento,
          receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail!, formCliente.email!),
          tipoDte: activeDoc?.idDoc ? activeDoc.idDoc : '01',
          cveDoc: `${formSucursal?.datosSerie?.serie}-${formSucursal?.datosSerie?.numeroactual}`,
          uuid: datosUUID?.CodigoGeneracion,
          fechaDoc: horasActuales ? (`${horasActuales.FechaDDMM} ${horasActuales.Hora}`) : `${getFechaFormato1()} ${getHoraNow()}`,
          canTotal: userLogin?.propina?.propina_activa && formCliente.checkPropina ? (parseFloat(calculosArrayProductos.total) + (parseFloat(calculosArrayProductos.total) * userLogin?.propina?.cantidad_propina)).toFixed(totalDigitos) : parseFloat(calculosArrayProductos.total).toFixed(totalDigitos),
          impuTotal: calculosArrayProductos.totalImpuesto1,
          impuTotal2: calculosArrayProductos.totalImpuesto2,
          impuTotal3: calculosArrayProductos.totalIvaPercibido,
          retencionRenta: parseFloat(calculosArrayProductos.totalRetencionRenta || "0").toFixed(totalDigitos),
          descuentoTotal: parseFloat(calculosArrayProductos.descuento).toFixed(totalDigitos),
          condicionOperacion: formFormaPago.condicion,
                    formapago: pagos.map((pago) => {
                        return (
                            {
                                codigo: pago.formaPago,
                                descripcion: pago.descripcion,
                                montoPago: parseFloat(pago.monto).toFixed(totalDigitos),
                                referencia: pago.numeroDocumento || '',
                                plazo: pago.plazo,
                                periodo: pago.periodo
                            }
                        )
                      }),
          cuerpoDocumento: [
            ...arrayProductos.map((p) => ({
              cantidad: parseFloat(p.cantidad || "0").toFixed(totalDigitos),
              precioUni: formCliente.checkExentoImpuesto ? (parseFloat(`${p.precio}`) / 1.13).toFixed(totalDigitos) : p.precio,
              impuesoItem: formCliente.checkExentoImpuesto === true ? "0.00" : p.totalImpuesto1,
              impuesoItem2: formCliente.checkExentoImpuesto === true ? "0.00" : p.totalImpuesto2,
              impuesto: p.impuesto1,
              impuesto2: p.impuesto2,
              descripcion: p.descripcion?.trim(),
              descuento: parseFloat(p.cantidadDescuento || "0").toFixed(totalDigitos),
              TipoMonto: formCliente.checkExentoImpuesto === true ? "1" : "0", // tipo monto 0 es gravado y 1 es exento 
              TipoItem: p.tipo === "s" ? "0" : "1",  // tipo item 0 es producto y 1 es servicio 
              unidad: p.unidadMedida,
              descUnidad: unidadesMedida.find((unidad) => unidad.codigo === p.unidadMedida)?.valor || '59',
              tributos: p.tributos ?? [],
              codigo: p.clave ?? ''
            })),
            ...(userLogin?.propina?.propina_activa && formCliente.checkPropina === true && (parseFloat(userLogin?.propina?.cantidad_propina) || 0) > 0           
            ? [{
                "cantidad": "1",
                "impuesoItem": "0",
                "precioUni": "0",
                "descripcion": "no gravado",
                "TipoItem": "1",
                "TipoMonto": "3",
                "unidad": "99",
                "descUnidad": "Otra",
                "tributos": [],
                "codigo": "",
                "ventaGravada": "0.00",
                "ventaExenta": "0.00",
                "ventaNoSuj": "0.00",
                "noGravado": (parseFloat(calculosArrayProductos.total) * (parseFloat(userLogin?.propina?.cantidad_propina) || 0)).toFixed(2),
                "ivaItem": "0.00"
              }]
              : []),
          ],
          receptor: {
            tipoDocumento: formCliente.tipoDocumento === 'sinDocumento' ? '' : formCliente.tipoDocumento,
            numDocumentoReceptor: doc,
            nombre: formCliente.nombre?.trim(),
            direccion: formCliente.direccion?.trim(),
            email: unirChipsReturnFirst(formCliente.chipsEmail!, formCliente.email!),
            telefono: formCliente.telefono?.trim(),
            nrc: formCliente.checkContribuyente && formCliente.nrc ? formCliente.nrc : "",
            codActividad: formCliente.actividad?.trim(),
            descAtvividad: formCliente.descripcion?.trim(),
            departamento: formCliente.departamento,
            municipio: formCliente.municipio,
          },
          otrosDocumentos: dataDocsAsociados.map((doc:any) => ({
            detalleDocumento: doc.descripcion,
            descDocumento: doc.identificacion,
            codDocAsociado: parseInt(doc.tipo),
            descCodDocAsociado: `${doc.tipo}-${docsAsociadosItems.find((tipo) => tipo.codigo === doc.tipo)?.valor}`
          })),
          tributos: calculosArrayProductos.resumenTributos,
        },
      ],
      tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
      tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
      idSucursal: userLogin?.datos?.sucursal_seleccionada,
      idEmpresa: `${userLogin?.datos?.codigo_empresa}`
    }
    
    if(formCliente.tipoDocumento && formCliente.numId) guardarClienteReceptor(formCliente, dispatch)
    if (!formCliente.tipoDocumento && !formCliente.checkCF) delete body.facturas[0].receptor
    let message = 'Se produjo un error al momento de emitir la factura, inténtelo nuevamente.'

    await http
      .post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if(res?.body?.NuevoToken) localStorage.setItem(KEYS.HACIENDA, res?.body?.TokenHacienda)        
        if (res?.body && !res.message) {
          if (res.body?.estado === 'PROCESADO') {
            window.scroll(0, 0)
            dispatch(facturacionSetDatosFactura(res.body))
            const {qr, message: ms} = await getQR(res?.body.JsonFactura)
            if (ms) dispatch(generalOpenModalError(ms))
            dispatch(facturacionSetDatosFactura({qr}))
            dispatch(facturacionSetFacturaEmitida(true))
            dispatch(facturacionSetModalFacturaEmitida(true))
            dispatch(facturacionSetModalEmitirFactura(false))
            return
          }          
          res.message = mostrarObservacionesError(res?.body?.observaciones, message, history, formCliente, dispatch)
        }
        dispatch(generalOpenModalError(res?.message ? res.message : message))
      })
      .catch((err: any) => {
        err.response.data.message = mostrarObservacionesError(err?.response?.data?.body?.observaciones, err?.response?.data?.body?.descripcionMsg, history, formCliente, dispatch)
        dispatch(generalOpenModalError(err?.response?.data?.message ? err?.response?.data?.message : message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

const mostrarObservacionesError = (arrayObservaciones: any, message: string, history: any, formCliente: ClienteF,dispatch: Dispatch<FacturacionAction>): string => {
  if (Array.isArray(arrayObservaciones)) {
    const errorMessage = construirErrorMessage(arrayObservaciones, formCliente);
    if (errorMessage) {
      message = errorMessage;
      if (contieneCampoReceptor(arrayObservaciones)) {
        dispatch(facturacionSetModalEmitirFactura(false));
        history.push('/emitir-factura/formulario');
      }
    }
  }
  return message;
};

const construirErrorMessage = (observaciones: string[], formCliente: ClienteF): string => {
  let errorMessage = '';
  observaciones.forEach((el: string) => {
    if (formCliente.tipoDocumento === 'sinDocumento') {
      if (el.trim().includes('#/receptor/tipoDocumento')) {
        errorMessage += `<li>La cantidad a facturar no es permitida para la opción "Sin documento", debe seleccionar otro tipo de documento.</li>`;
      }
      if (el.trim().includes('#/receptor/numDocumento')) {
        errorMessage += `<li>La cantidad a facturar no es permitida para la opción "Sin documento", debe ingresar un número de documento.</li>`;
      }
    } else if (formCliente.checkCF && el.trim().includes("Campo #/receptor contiene un valor inválido")) {
      errorMessage += `<li>El total a facturar no es permitido para realizar la factura como Consumidor Final, tiene que ingresar un tipo de documento con los datos del cliente receptor.</li>`;
    } else if (el.trim().includes('Campo #/receptor/')) {
      el = el.replaceAll('Campo #/receptor/', 'Formulario con datos del cliente el campo: ');
      errorMessage += `<li>${el} o está vacío.</li>`;
    } else errorMessage += `<li>${el}.</li>`;
  });
  if (errorMessage)  errorMessage = `No se pudo generar la factura, Hacienda solicita llenar los siguientes campos:<br><br><ol>${errorMessage}</ol>`;
  return errorMessage;
};

const contieneCampoReceptor = (observaciones: string[]): boolean => {
  const cadena = 'Campo #/receptor';
  return observaciones.some((el: string) => el.trim().includes(cadena));
};

export const creditoFiscalEmitirModal =
  (history: any) => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const {activeDoc} = getState().documentos
    const user = localStorage.getItem(KEYS.ID_CLIENT)
    const userLogin = getState().userLogin
    if (getState().general.loader) return

    dispatch(generalShowLoader(true))
    const {formCliente, formSucursal, arrayProductos, calculosArrayProductos, datosUUID} =
      getState().facturacion

    let doc = formCliente.numId?.trim().replaceAll('-', '')
    let body: any = {
      id_user: user,
      facturas: [
        {
          idsucursaldocumento: formSucursal?.datosSerie?.idsucursaldocumento,
          tipoDte: activeDoc?.idDoc ? activeDoc.idDoc : '01',
          cveDoc: `${formSucursal?.datosSerie?.serie}-${formSucursal?.datosSerie?.numeroactual}`,
          uuid: datosUUID?.CodigoGeneracion,
          fechaDoc: `${getFechaFormato1()} ${new Date().toLocaleTimeString()}`,
          canTotal: userLogin?.propina?.propina_activa ? parseFloat(calculosArrayProductos.total) + (parseFloat(calculosArrayProductos.total) * userLogin?.propina?.cantidad_propina) : calculosArrayProductos.total,
          impuTotal: calculosArrayProductos.totalImpuesto1,
          impuTotal2: calculosArrayProductos.totalImpuesto2,
          impuTotal3: '0',
          descuentoTotal: calculosArrayProductos.descuento,
          cuerpoDocumento: [
              ...arrayProductos.map((p) => ({
              cantidad: p.cantidad,
              precioUni: p.precio,
              impuesoItem: p.totalImpuesto1,
              impuesoItem2: p.totalImpuesto2,
              impuesto: p.impuesto1,
              impuesto2: p.impuesto2,
              impuesto3: '0',
              descripcion: p.descripcion?.trim(),
              descuento: p.cantidadDescuento,tributos: p.tributos ?? [],
              codigo: p.clave ?? ''
            })),
            ...(userLogin?.propina?.propina_activa && (parseFloat(userLogin?.propina?.cantidad_propina) || 0) > 0                     
              ? [{
                "cantidad": "1",
                "impuesoItem": (parseFloat(calculosArrayProductos.total) * (parseFloat(userLogin?.propina?.cantidad_propina) || 0)).toFixed(2),
                "descripcion": "no gravado",
                "tributos": [],
                "codigo": ""
              }]
              : []),
          ],
          receptor: {
            nit: doc,
            rfc: doc,
            tipoDocumento: '36',
            numDocumentoReceptor: doc,
            nombre: formCliente.nombre?.trim(),
            direccion: formCliente.direccion?.trim(),
            email: formCliente.email?.trim(),
            telefono: formCliente.telefono?.trim(),
            nrc: formCliente.nrc?.trim(),
            codActividad: formCliente.actividad?.trim(),
            descAtvividad: formCliente.descripcion?.trim(),
            departamento: formCliente.departamento,
            municipio: formCliente.municipio,
          },
        },
      ],
      tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
      tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
      idSucursal: userLogin?.datos?.sucursal_seleccionada,
      idEmpresa: `${userLogin?.datos?.codigo_empresa}`
    }
    if (!formCliente.tipoDocumento || formCliente.tipoDocumento === '-1')
      delete body.facturas[0].receptor
    let message = 'Se produjo un error al momento de emitir la factura, inténtelo nuevamente.'

    await http
      .post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if(res?.body?.NuevoToken){
          localStorage.setItem(KEYS.HACIENDA, res?.body?.TokenHacienda)
        }
        if (res?.body && !res.message) {
          if (res.body?.estado === 'PROCESADO') {
            await dispatch(facturacionSetDatosFactura(res.body))

            const {qr, message: ms} = await getQR(res?.body.JsonFactura)
            if (ms) dispatch(generalOpenModalError(ms))
            dispatch(facturacionSetDatosFactura({qr}))

            await dispatch(facturacionSetFacturaEmitida(true))
            await dispatch(facturacionSetModalFacturaEmitida(true))
            await dispatch(facturacionSetModalEmitirFactura(false))
            return
          }
          if (res?.body?.observaciones && Array.isArray(res.body.observaciones)) {
            let cadena = 'Campo #/receptor contiene un valor inválido'
            let value = res.body.observaciones.find((ob: any) => ob.trim() === cadena)
            if (value) {
              message = 'Debe llenar el formulario con los datos del cliente'
              await dispatch(facturacionSetModalEmitirFactura(false))
              history.push('/otros-documentos/emitir/formulario')
            }
          }
        }
        dispatch(generalOpenModalError(res.message || message))
      })
      .catch((err: any) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const notaCreditoEmitirModal =
  (history: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
    const {activeDoc} = getState().documentos
    const {formFilter} = getState().historial
    const {activeFactura} = getState().historial
    const receptor = activeFactura?.DetallesDTE?.receptor;
    const user = localStorage.getItem(KEYS.ID_CLIENT)
    const userLogin = getState().userLogin
    if (getState().general.loader) return

    dispatch(generalShowLoader(true))
    const {formSucursal, arrayProductos, calculosArrayProductos, datosUUID} = getState().facturacion
    const {unidadesMedida} = getState().catalogos

    let body: any = {
      idserviciodte: activeFactura?.idserviciodte,
      id_user: user,
      facturas: [
        {
          idsucursaldocumento: formSucursal?.datosSerie?.idsucursaldocumento,
          tipoDte: activeDoc?.idDoc ? activeDoc.idDoc : '01',
          docAnt: activeFactura?.DetallesDTE?.identificacion?.numeroControl,
          cveDoc: `${formSucursal?.datosSerie?.serie}-${formSucursal?.datosSerie?.numeroactual}`,
          uuid: datosUUID?.CodigoGeneracion,
          fechaDoc: `${getFechaFormato1()} ${new Date().toLocaleTimeString()}`,
          canTotal: userLogin?.propina?.propina_activa ? parseFloat(calculosArrayProductos.total) + (parseFloat(calculosArrayProductos.total) * userLogin?.propina?.cantidad_propina) : calculosArrayProductos.total,
          impuTotal: calculosArrayProductos.totalImpuesto1,
          impuTotal2: calculosArrayProductos.totalImpuesto2,
          impuTotal3: '0',
          descuentoTotal: calculosArrayProductos.descuento,
          condicion: ' ',
          receptor: {
            rfc: receptor.nit,
            nit: receptor.nit,
            nombre: receptor.nombre,
            direccion: receptor.direccion.complemento,
            email: receptor.correo,
            telefono: receptor.telefono,
            nrc: receptor.nrc,
            codActividad: receptor.codActividad,
            descAtvividad: receptor.descActividad,
            departamento: receptor.direccion.departamento,
            municipio: receptor.direccion.municipio,
          },
          docRelacionado: [
            {
              tipoDocumento: '03',
              numeroDocumento: activeFactura?.DetallesDTE?.identificacion?.codigoGeneracion,
              fechaEmision: `${activeFactura?.DetallesDTE?.identificacion?.fecEmi} ${activeFactura?.DetallesDTE?.identificacion?.horEmi}`,
            },
          ],
          cuerpoDocumento: [
            ...arrayProductos.map((p) => ({
              numeroDocumento: activeFactura?.DetallesDTE?.identificacion?.codigoGeneracion,
              cantidad: p.cantidad,
              precioUni: p.precio,
              impuesoItem: p.totalImpuesto1,
              impuesoItem2: p.totalImpuesto2,
              impuesto: p.impuesto1,
              impuesto2: p.impuesto2,
              descripcion: p.descripcion?.trim(),
              descuento: p.cantidadDescuento,
              unidad: p.unidadMedida,
              descUnidad: unidadesMedida.find((unidad) => unidad.codigo === p.unidadMedida)?.valor || '59',
              tributos: p.tributos ?? [],
              codigo: p.clave ?? ''
            })),
        ...(userLogin?.propina?.propina_activa && (parseFloat(userLogin?.propina?.cantidad_propina) || 0) > 0                
              ? [{
                "cantidad": "1",
                "impuesoItem": (parseFloat(calculosArrayProductos.total) * (parseFloat(userLogin?.propina?.cantidad_propina) || 0)).toFixed(2),
                "descripcion": "no gravado",
                "tributos": [],
                "codigo": ""
              }]
              : []),
          ],
        },
      ],
      tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
      tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
      idSucursal: userLogin?.datos?.sucursal_seleccionada,
      idEmpresa: `${userLogin?.datos?.codigo_empresa}`
    }
    let message = 'Se produjo un error al momento de emitir la factura, inténtelo nuevamente.'

    await http
      .post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if(res?.body?.NuevoToken){
          localStorage.setItem(KEYS.HACIENDA, res?.body?.TokenHacienda)
        }
        if (res?.body && !res.message) {
          if (res.body?.estado === 'PROCESADO') {
            await dispatch(facturacionSetDatosFactura(res.body))

            const {qr, message: ms} = await getQR(res?.body.JsonFactura)
            if (ms) dispatch(generalOpenModalError(ms))
            dispatch(facturacionSetDatosFactura({qr}))
            dispatch(getTransactions(formFilter));

            await dispatch(facturacionSetFacturaEmitida(true))
            await dispatch(facturacionSetModalFacturaEmitida(true))
            await dispatch(facturacionSetModalEmitirFactura(false))
            return
          }
          if (res?.body?.observaciones && Array.isArray(res.body.observaciones)) {
            let cadena = 'Campo #/receptor contiene un valor inválido'
            let value = res.body.observaciones.find((ob: any) => ob.trim() === cadena)
            if (value) {
              message = 'Debe llenar el formulario con los datos del cliente'
              await dispatch(facturacionSetModalEmitirFactura(false))
              history.push('/otros-documentos/emitir/formulario')
            }
          }
        }
        dispatch(generalOpenModalError(res.message || message))
      })
      .catch((err: any) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const facturacionCloseModalFacturaEmitida =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    dispatch(facturacionModalsClose())
  }

export const facturacionVerDetalleDocumentoEmitido =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    dispatch(facturacionSetActivarOpciones())
    dispatch(facturacionModalsClose())
  }

export const facturacionCloseModalDocumentoEmitida =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    dispatch(handleRestartStateFormaPago())
    dispatch(facturacionClearAll())
    dispatch(docsAsociadosReset())
    dispatch(facturacionModalsClose())
  }

export const facturacionOpenCloseModalImprimir =
  (flag: boolean = false, modoTicket: boolean = false) =>
  async (dispatch: Dispatch<FacturacionAction>) => {
    await dispatch(facturacionSetModalImpresion({modalFlag: flag, modoTicket: modoTicket}))
    await dispatch(facturacionSetModalFacturaEmitida(!flag))
  }

export const facturacionOpenCloseModalEmail =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<FacturacionAction>) => {
    await dispatch(facturacionSetModalEmail(flag))
    await dispatch(facturacionSetModalFacturaEmitida(!flag))
  }

export const facturacionOpenMasOpciones = () => async (dispatch: Dispatch<FacturacionAction>) => {
  await dispatch(facturacionSetActivarOpciones())
  await dispatch(facturacionSetModalFacturaEmitida(true))
}

export const facturacionOpenCloseModalAnular2 =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<FacturacionAction>) => {
    await dispatch(facturacionSetModalAnular(flag))
    await dispatch(facturacionSetModalFacturaEmitida(!flag))
  }

export const facturacionVerificarAnulacion = (funcionRedirigir: () => void) => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
  const {resultAnulaciones} = getState().historial
  const anulado = getState().sujetoExcluido.anulado

  // Anulacion unitaria
  if (!anulado) {
    dispatch(facturacionAnulado(resultAnulaciones[0].result))
    if (resultAnulaciones[0].result) {
      dispatch(generalOpenModalMessage("Documento anulado", "El documento ha sido anulado exitosamente."))
      funcionRedirigir()
      dispatch(setResultAnulaciones([]))
      return
    } 
    dispatch(generalOpenModalError(resultAnulaciones[0].msg))
  }

  dispatch(setResultAnulaciones([]))
  dispatch(facturacionSetModalAnular(false))
  dispatch(facturacionSetModalFacturaEmitida(true))
}

export const facturacionOpenCloseModalAnular =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<FacturacionAction>) => {
    await dispatch(facturacionSetModalAnular(flag))
    await dispatch(facturacionSetModalFacturaEmitida(false))
  }

export const facturacionOpenCloseModalAnularV2 =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<FacturacionAction>) => {
    await dispatch(facturacionSetModalAnular(flag))
  }
